import React from "react";
import { motion, useReducedMotion } from "framer-motion";

const DELAY_MAP = {
  "sv-d1": 0.08,
  "sv-d2": 0.16,
  "sv-d3": 0.24,
  "sv-d4": 0.32,
};

const OFFSETS = {
  up: { y: 28, x: 0 },
  left: { y: 0, x: -28 },
  right: { y: 0, x: 28 },
  scale: { y: 12, x: 0, scale: 0.96 },
};

/**
 * Drop-in scroll reveal. Preserves className / delayClass API.
 * @param {"up"|"left"|"right"|"scale"} [variant]
 */
const Reveal = ({
  children,
  className = "",
  delayClass = "",
  variant = "up",
  delay,
}) => {
  const reduce = useReducedMotion();
  const offset = OFFSETS[variant] || OFFSETS.up;
  const resolvedDelay =
    typeof delay === "number" ? delay : DELAY_MAP[delayClass] ?? 0;

  if (reduce) {
    return (
      <div className={`sv-reveal ${delayClass} ${className}`.trim()}>
        {children}
      </div>
    );
  }

  return (
    <motion.div
      className={`sv-reveal ${delayClass} ${className}`.trim()}
      initial={{
        opacity: 0,
        y: offset.y || 0,
        x: offset.x || 0,
        scale: offset.scale ?? 1,
      }}
      whileInView={{ opacity: 1, y: 0, x: 0, scale: 1 }}
      viewport={{ once: true, amount: 0.18, margin: "0px 0px -40px 0px" }}
      transition={{
        duration: 0.7,
        delay: resolvedDelay,
        ease: [0.22, 1, 0.36, 1],
      }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
